import { PageSEOProps } from "./types";

export function getOpenGraphImagesFromSEOContentModel(
  seo: PageSEOProps["seo"],
) {
  if (!seo?.seoImage && !seo?.seoImage?.url) return;

  return {
    images: [
      {
        url: seo.seoImage?.url as string,
        width: seo.seoImage?.width ?? null,
        height: seo.seoImage?.height ?? null,
        alt: seo.seoImage?.description ?? "",
      },
    ],
  };
}
